import React from 'react';

export default function UTCOffsetDescription({ utcoffset }: { utcoffset: number }) {
    const sign = utcoffset < 0 ? '-' : '+';
    const hours = Math.abs(utcoffset / 3600);
    const minutes = Math.round(Math.abs(utcoffset % 3600) / 60);
    return (
        <>UTC{sign}{hours}:{minutes.toString().padStart(2, '0')}</>
    )
}